import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  ratesUnavailable: {
    defaultMessage: "Carriers that do not send rates will appear as {currencyCode} -. You will still be charged the carrier's rate.",
    description: 'Description for the tooltip that explains why some rates are not available',
    id: 'mRbVKz',
  },
  estimatedRates: {
    defaultMessage: 'Estimated Rates',
    description: 'Estimated rates header for the rate list',
    id: 'V4BiLs',
  },
});
